<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <!-- Calculation Name -->
      <b-form-group
        label="Calculation Name"
        label-for="mc-calculation-name"
      >
        <validation-provider
          #default="{ errors }"
          name="Calculation Name"
          rules="required"
        >
          <b-form-input
            v-model="item.calculationName"
            :state="errors.length > 0 ? false : null"
            placeholder="Calculation Name"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Query -->
      <b-form-group
        label="Query"
        label-for="mc-query"
      >
        <validation-provider
          #default="{ errors }"
          name="Query"
          rules="required"
        >
          <b-form-textarea
            v-model="item.query"
            :state="errors.length > 0 ? false : null"
            rows="10"
            placeholder="Query"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Preview-->
      <b-row>
        <b-col sm="2">
          <v-select
            id="vue-select-period-start"
            v-model="selectedPeriodStart"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionPeriod"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <b-col sm="2">
          <v-select
            id="vue-select-period-end"
            v-model="selectedPeriodEnd"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optionPeriod"
            :clearable="false"
            class="mb-2"
          />
        </b-col>
        <b-col>
          <b-button
            variant="warning"
            @click="preview"
          >
            Preview
          </b-button>
          <b-button
            v-if="role=='superadmin'"
            variant="danger"
            class="ml-1"
            @click="execute"
          >
            Execute
          </b-button>
          <b-button
            v-if="items && items.length"
            class="ml-2"
            variant="warning"
            @click="clear"
          >
            Clear Results
          </b-button>
        </b-col>
      </b-row>

      <template>
        <b-table
          v-if="items && items.length"
          style="height:100%"
          :no-border-collapse="noCollapse"
          responsive
          :items="items"
          :fields="fields"
          :sort-compare="mysorter"
        >
          <!-- sort-compare  -->
          <template #head()="data">
            <!-- eslint-disable vue/no-v-html -->
            <span
              class="text-nowrap"
              v-html="data.field.key"
            />
            <!--eslint-enable-->
          </template>
          <template #cell()="data">
            <!-- eslint-disable vue/no-v-html -->
            <sup v-if="data.value.zbase">%</sup>
            <span
              v-if="data.field.key !== 'orjref'"
              class="text-nowrap"
              v-html="$t(data.value.val == ' ' ? 'TOTAL' : data.value.val)"
            />
            <b-link
              v-if="data.field.key === 'orjref'"
              @click="cellClick(data)"
            >
              {{ $t(data.value.val) }}
            </b-link>

            <!--eslint-enable-->
          </template>
        </b-table>
        <h1
          v-else-if="inProgress"
          class="text-center"
        >
          Running...
        </h1>
        <h1
          v-else-if="items && items.length === 0"
          class="text-center"
        >
          No data
        </h1>
        <h1
          v-else-if="previewFailed"
          class="text-center"
        >
          Preview Failed!
        </h1>

        <pre v-if="errMessage">{{ errMessage }}</pre>
      </template>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormTextarea, BRow, BCol, BButton, BTable,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { getUserData } from '@/auth/utils'

import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BRow,
    BCol,
    BButton,
    BTable,
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      inProgress: false,
      defaultItem: {
        calculationName: null,
        query: null,
      },
      optionPeriod: this.$store.state.globals.periodList,
      selectedPeriodStart: this.$store.state.globals.periodList[0],
      selectedPeriodEnd: this.$store.state.globals.periodList[0],
      result: null,
      items: null,
      fields: null,
      previewFailed: false,
      required,
      role: null,
      errMessage: null,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  created() {
    this.item.projectId = this.projectId
    this.role = getUserData().role
  },
  methods: {
    clear() {
      this.result = null
      this.items = null
      this.fields = null
    },
    // for superadmin
    execute() {
      this.inProgress = true
      this.errMessage = null
      this.clear()
      const postItem = JSON.parse(JSON.stringify(this.item))
      useJwt.axiosIns.post('customcalculation/execute', postItem)
        .then(response => {
          this.inProgress = false
          if (response.data) {
            if (response.data === 'OK') {
              this.errMessage = response.data
            } else {
              this.errMessage = response.data
            }
          }
        })
        .catch(e => {
          this.previewFailed = true
          this.inProgress = false
          console.log(e)
        })
    },
    preview() {
      this.inProgress = true
      this.clear()
      const postItem = JSON.parse(JSON.stringify(this.item))
      postItem.fromWave = this.selectedPeriodStart
      postItem.toWave = this.selectedPeriodEnd
      useJwt.axiosIns.post('box/previewCustomCalculation', postItem)
        .then(response => {
          this.inProgress = false
          if (response.data) {
            this.result = response.data
            if (this.result.previewFailed) {
              this.previewFailed = true
            } else if (this.result.headerRow) {
              this.fields = []
              this.result.headerRow.forEach(x => {
                this.fields.push({
                  key: x.value,
                  label: x.label,
                })
              })

              for (let i = 0; i < this.fields.length; i += 1) {
                this.fields[i] = {
                  key: this.fields[i].key,
                  testLabel: this.fields[i].label,
                  sortable: true,
                }
              }

              this.items = []
              this.result.rows.forEach(element => {
                const newRow = {}
                this.fields.forEach(h => {
                  if (element[this.fields.indexOf(h)]) {
                    newRow[h.key] = {
                      val: element[this.fields.indexOf(h)].value,
                      lbl: element[this.fields.indexOf(h)].labels && element[this.fields.indexOf(h)].labels.length > 0 ? `${element[this.fields.indexOf(h)].labels.map(label => this.formatLabel(label)).join('')}` : '',
                    }
                  }
                })
                this.items.push(newRow)
              })
            }
          }
        })
        .catch(e => {
          this.previewFailed = true
          this.inProgress = false
          console.log(e)
        })
    },
    mysorter(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
      let result = null
      const a = aRow[key].val // or use Lodash `_.get()`
      const b = bRow[key].val

      if (
        (typeof a === 'number' && typeof b === 'number')
        || (a instanceof Date && b instanceof Date)
      ) {
        // If both compared fields are native numbers or both are native dates
        // eslint-disable-next-line no-nested-ternary
        result = a < b ? -1 : a > b ? 1 : 0
      }
      // Otherwise stringify the field data and use String.prototype.localeCompare
      result = this.toString(a).localeCompare(this.toString(b), compareLocale, compareOptions)
      return result
    },
    toString(value) {
      if (value === null || typeof value === 'undefined') {
        return ''
      } if (value instanceof Object) {
        return Object.keys(value)
          .sort()
          .map(key => toString(value[key]))
          .join(' ')
      }
      return String(value)
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.item.id) {
            useJwt.axiosIns.patch('customcalculation', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('customcalculation', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
